import React from 'react'
import { Label } from 'reactstrap'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { SquaresFour, Rows } from "phosphor-react"
import Checkbox from './Checkbox'
import Select from './Select'
import Skeleton from './Skeleton'
import Switch from './Switch'

class Filter extends React.Component {

    render() {
        const { t } = this.props
        return (
            <div className="col-xl-12">
                {
                    this.props.skeleton ?
                        <div className='px-20'>
                            <Skeleton className="custom-filter-bg mx-0" />
                        </div>
                        :
                        <div className="custom-filter-bg">
                            <div className="custom-filter-filters">
                                {
                                    this.props.gradeSwitcher ? 
                                        <Switch
                                            state={this.props.gradeSwitcherState}
                                            onChange={this.props.addToFilters}
                                            loading={this.props.loading}
                                            text="Показывать только доступные"
                                        /> : ''
                                }
                                {
                                    this.props.types.map(({ type, count, checked }) => (
                                        <div className="custom-filter-filter" key={`type-${type}`}>
                                            <Label for={`type-${type}`} className="custom-label no-line-height mb-0 sm-font-size">
                                                <Checkbox
                                                    id={`type-${type}`}
                                                    value={type}
                                                    checked={checked}
                                                    onChange={(e) => {
                                                        this.props.updateCheckboxes(e)
                                                        this.props.addToFilters('type', type)
                                                    }}
                                                />
                                                {t(`course-type-${type}`)} ({count})
                                            </Label>
                                        </div>
                                    ))
                                }
                            </div>
                            <div className="sort-switcher-wrap d-flex justify-content-between">
                                <div className="custom-filter-sort">
                                    <span className="sort-by sm-font-size">{t('catalog-sort-by')}</span>
                                    <Select
                                        options={this.props.options}
                                        updateItems={this.props.updateItems}
                                        filters={this.props.filters}
                                        page={this.props.page}
                                        limit={this.props.limit}
                                        lang={this.props.lang}
                                        token={this.props.token}
                                        t={t}
                                    />
                                </div>
                                <div className="custom-cols-switchers">
                                    <button id="squaresFour" className="btn cinema-btn squares active" onClick={this.props.squaresFour}>
                                        <div className="cinema-btn-content">
                                            <SquaresFour size={20} color={'#ffffff'} />
                                        </div>
                                    </button>
                                    <button id="squaresTwo" className="btn cinema-btn squares" onClick={this.props.squaresTwo}>
                                        <div className="cinema-btn-content">
                                            <Rows size={20} color={'#ffffff'} />
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                }
            </div >
        )
    }
}

Filter.propTypes = {
    t: PropTypes.func,
    types: PropTypes.array,
    updateCheckboxes: PropTypes.func,
    addToFilters: PropTypes.func,
    squaresFour: PropTypes.func,
    squaresTwo: PropTypes.func,
    options: PropTypes.array,
    updateItems: PropTypes.func,
    filters: PropTypes.array,
    page: PropTypes.number,
    limit: PropTypes.number,
    lang: PropTypes.string,
    token: PropTypes.string,
    skeleton: PropTypes.bool,
    gradeSwitcher: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.any,
    ]),
    gradeSwitcherState: PropTypes.oneOfType([
        PropTypes.obj,
        PropTypes.any,
    ]),
    loading: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.any,
    ]),
}

export default withTranslation()(Filter)



// WEBPACK FOOTER //
// ./src/components/UI/Filter.jsx